import { render, staticRenderFns } from "./card-slider-yuri.vue?vue&type=template&id=3b3606a7&scoped=true&"
import script from "./card-slider-yuri.vue?vue&type=script&lang=js&"
export * from "./card-slider-yuri.vue?vue&type=script&lang=js&"
import style0 from "./card-slider-yuri.vue?vue&type=style&index=0&id=3b3606a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3606a7",
  null
  
)

export default component.exports